'use strict'

class ScrollToTop {
	static SELECTOR_CLASS_CONTAINER = '.returntotop__container'
	static PROP_SCROLL_THRESHOLD = 100
	static PROP_SCROLL_DURATION = 200
	static PROP_FADE_DURATION = 600
	static PROP_FADE_INTERVAL = 20
	static PROP_DISPLAY_BLOCK = 'block'
	static PROP_DISPLAY_NONE = 'none'

	init() {
		const container = document.querySelector( ScrollToTop.SELECTOR_CLASS_CONTAINER )
		if ( !container ) {
			return
		}

		window.addEventListener( 'scroll', () => {
			this.handleScroll( container )
		} )

		container.addEventListener( 'click', ( e ) => {
			e.preventDefault()
			this.scrollToTop()
		} )
	}

	handleScroll( container ) {
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

		if ( scrollTop > ScrollToTop.PROP_SCROLL_THRESHOLD ) {
			this.fadeIn( container )
		} else {
			this.fadeOut( container )
		}
	}

	fadeIn( element ) {
		if ( element.style.display === ScrollToTop.PROP_DISPLAY_BLOCK ) {
			return
		}

		element.style.opacity = '0'
		element.style.display = ScrollToTop.PROP_DISPLAY_BLOCK

		const steps = ScrollToTop.PROP_FADE_DURATION / ScrollToTop.PROP_FADE_INTERVAL
		const increment = 1 / steps
		let currentOpacity = 0

		const fadeInterval = setInterval( () => {
			currentOpacity += increment
			if ( currentOpacity >= 1 ) {
				element.style.opacity = '1'
				clearInterval( fadeInterval )
			} else {
				element.style.opacity = currentOpacity.toString()
			}
		}, ScrollToTop.PROP_FADE_INTERVAL )
	}

	fadeOut( element ) {
		if ( element.style.display === ScrollToTop.PROP_DISPLAY_NONE ) {
			return
		}

		const steps = ScrollToTop.PROP_FADE_DURATION / ScrollToTop.PROP_FADE_INTERVAL
		const decrement = 1 / steps
		let currentOpacity = parseFloat( element.style.opacity ) || 1

		const fadeInterval = setInterval( () => {
			currentOpacity -= decrement
			if ( currentOpacity <= 0 ) {
				element.style.opacity = '0'
				element.style.display = ScrollToTop.PROP_DISPLAY_NONE
				clearInterval( fadeInterval )
			} else {
				element.style.opacity = currentOpacity.toString()
			}
		}, ScrollToTop.PROP_FADE_INTERVAL )
	}

	scrollToTop() {
		const start = window.scrollY
		const duration = ScrollToTop.PROP_SCROLL_DURATION
		const startTime = performance.now()

		function animateScroll( currentTime ) {
			const elapsed = currentTime - startTime
			const progress = Math.min( elapsed / duration, 1 )
			const ease = progress < 0.5
				? 2 * progress * progress
				: -1 + (4 - 2 * progress) * progress

			window.scrollTo( 0, Math.round( start * (1 - ease) ) )

			if ( progress < 1 ) {
				requestAnimationFrame( animateScroll )
			}
		}

		requestAnimationFrame( animateScroll )
	}
}

export default function init() {
	new ScrollToTop().init()
}
